<app-full-screen>
  <div class="wizard-step-container fixed-container">
    <ng-content></ng-content>
  </div>
  <div class="mb-5">
    <ng-content select="[footer]"></ng-content>
  </div>
</app-full-screen>
